/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects'
import getRegionalProjectDataActions, {
    getRegionalProjectDataTypes,
} from '../../../redux/donneesSocioEconomique/getRegionalProjectsData'
import { Get } from '../../../serveur/axios'

function* getRegionalProjectDataSagas({ response }) {
    const { governorate, year, yearSecondary } = response
    let url = 'regional-project-filtre?'

    if (governorate) {
        url = `${url}&governorat=${governorate}`
    }
    if (year) {
        url = `${url}&year=${year}`
    }
    if (yearSecondary) {
        url = `${url}&yearSecondary=${yearSecondary}`
    }
    try {
        const res = yield Get(url)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getRegionalProjectDataActions.getRegionalProjectDataSuccess(
                        res
                    )
                ),
            ])
        } else {
            yield put(
                getRegionalProjectDataActions.getRegionalProjectDataFailure(res)
            )
        }
    } catch (error) {
        yield put(
            getRegionalProjectDataActions.getRegionalProjectDataFailure(error)
        )
    }
}

export function* getRegionalProjectDataSaga() {
    yield takeLatest(
        getRegionalProjectDataTypes.GET_REGIONAL_PROJECT_DATA_REQUEST,
        getRegionalProjectDataSagas
    )
}
